function RoomShared(props) {
    return ""
}

export default RoomShared;